import { getPosts } from '../api/posts'
import { NavSlider, NavSliderItem } from '../components/nav-slider/index'

export default {
  name: 'Blog',
  components: {
    NavSlider,
    NavSliderItem,
  },
  data() {
    return {
      nextPage: 2,
    }
  },
  methods: {
    loadMore() {
      getPosts({ paged: this.nextPage, posts_per_page: 9 }).then(res => {
        if (!res.data.next_page) {
          this.$refs.load_more.style.display = 'none'
        }

        this.$refs.post_list.innerHTML += res.data.html
        this.nextPage += 1
      })
    },
  },
}
